'use strict';

module.exports = {
  template: require('./cn-transpire-form.html'),
  controller: require('./cn-transpire-form.controller'),
  controllerAs: 'vm',

  bindings: {
    onSubmit: '&',
    onChange: '&'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-transpire-form/index.js
 ** module id = 93
 ** module chunks = 0
 **/